module.exports = __webpack_public_path__ + "static/stabilization-dark-adba968ad38620b1405f6f9b2287a395.svg";